import React from "react";
import "./Location.css";

const Location = () => {
  const location = [
    { icon: "🇦🇪 ", title: "United Arab Emirates", subtitle: "DUBAI" },
    { icon: "🇵🇰", title: "Pakistan", subtitle: "ISLAMABAD+KARACHI" },
    { icon: "🇮🇩", title: "Indonesia", subtitle: "JAKARTA" },
  ];
  return (
    <div>
      <section className="our-location">
        <h2>Location: We are Based in </h2>

        <div className="value-grid">
          {location.map((val, index) => (
            <div className="value-card" key={index}>
              <div className="value-icon">{val.icon}</div>
              <h3>{val.title}</h3>
              <p>{val.subtitle}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Location;
